export const faqTranslations = {
  FAQ_TITLE: 'FAQ',
  FAQ_SUBTITLE: 'Veelgestelde vragen',
}
